import { ENGLISH_IQ_SUB_BANDS, englishIqToSubBand } from '@repo/config';

export function resolveAssessmentBand(score: number): {
  cefr: string;
  score: number;
  subBand: string;
} {
  const minimumScore = ENGLISH_IQ_SUB_BANDS[0].minScore;
  const maximumScore = ENGLISH_IQ_SUB_BANDS.at(-1)?.maxScore ?? minimumScore;
  const clampedScore = Math.min(Math.max(Math.round(score), minimumScore), maximumScore);
  const band = englishIqToSubBand(clampedScore);
  return { cefr: band.cefr, score: clampedScore, subBand: band.subBand };
}
